<template>
    <div class="absolute h-full">
        <div class="grid grid-cols-2 h-1/2">
            <div class="bg-gray-300">
                <img
                    class="cursor-pointer"
                    :src="firstPhoto"
                    v-if="firstPhoto"
                    @click="photoZoom(firstPhotoIndex)"
                />
            </div>
            <div class="bg-gray-400">
                <img
                    class="cursor-pointer"
                    :src="secondPhoto"
                    v-if="secondPhoto"
                    @click="photoZoom(secondPhotoIndex)"
                />
            </div>
        </div>
        <div class="grid grid-cols-2 h-1/2">
            <div class="bg-gray-400">
                <img
                    class="cursor-pointer"
                    :src="thirdPhoto"
                    v-if="thirdPhoto"
                    @click="photoZoom(thirdPhotoIndex)"
                />
            </div>
            <div class="bg-gray-300">
                <img
                    class="cursor-pointer"
                    :src="fourthPhoto"
                    v-if="fourthPhoto"
                    @click="photoZoom(fourthPhotoIndex)"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        photos: {
            type: Array,
            required: true,
        },
        page: {
            type: Number,
            required: true,
        },
    },
    computed: {
        firstPhoto() {
            return this.photos[this.firstPhotoIndex];
        },
        secondPhoto() {
            return this.photos[this.secondPhotoIndex];
        },
        thirdPhoto() {
            return this.photos[this.thirdPhotoIndex];
        },
        fourthPhoto() {
            return this.photos[this.fourthPhotoIndex];
        },
        firstPhotoIndex() {
            return this.page * 4;
        },
        secondPhotoIndex() {
            return this.page * 4 + 1;
        },
        thirdPhotoIndex() {
            return this.page * 4 + 2;
        },
        fourthPhotoIndex() {
            return this.page * 4 + 3;
        },
    },
    methods: {
        photoZoom(index) {
            this.$emit("zoom", index);
        },
    },
};
</script>
